export default __webpack_public_path__ + "static/media/visa_logo.b1f5a8eb.webp";